import { type TFunction } from 'react-i18next';
import { type RouterSpecsFragment } from '../../../../../api/fragments/RouterSpecs';
import * as implementations from './implementations';

type LayoutSpecs = RouterSpecsFragment['layout'];

export const getImplementation = (layout: LayoutSpecs) => implementations[layout?.__typename || 'NoneLayout'];

export const renderViewPanel = (layout: LayoutSpecs) => {
    const { ViewPanelComponent } = getImplementation(layout);

    return <ViewPanelComponent layout={layout as any} />;
};

export const getTitle = (t: TFunction, layout: LayoutSpecs) => getImplementation(layout).getTitle(t);

export const getInitialValues = (layout: LayoutSpecs) => getImplementation(layout).getInitialValues(layout as any);

export { implementations };
